export const WebsocketClients = Object.freeze({
    SHOOT_ROBOT_STATUS: "SHOOT_ROBOT_STATUS",
    ORG_ROBOT_STATUS: "ORG_ROBOT_STATUS",
    SHOOT_SETUP: "SHOOT_SETUP",
    LAUNCHPAD: "LAUNCHPAD",
});

export const PayloadActions = Object.freeze({
    CONNECT_AIR_ID_GROUPS: "CONNECT_AIR_ID_GROUPS",
    FETCH_LATEST_ROBOT_STATUS: "FETCH_LATEST_ROBOT_STATUS",
    ROBOT_STATUS_UPDATE: "ROBOT_STATUS_UPDATE"
});

// Mirrors backend/generic/websocket.py
export const WsCloseCodes = Object.freeze({
    UNAUTHENTICATED: 4401, // token missing/invalid -> log out
    REVOKED: 4403, // a robot is not permitted -> stop
    BAD_REQUEST: 4400, // malformed message -> stop
    SUBSCRIBE_TIMEOUT: 4408, // nothing subscribed -> wait for the next subscription
});

export const CallbackActions = Object.freeze({
    WS_STATUS_UPDATE: "WS_STATUS_UPDATE",
    ROBOT_STATUS_UPDATE: "ROBOT_STATUS_UPDATE",
});

export const ROBOT_STATUS_DATA_KEYS = Object.freeze({
    ROBOT_NAME: "robot_name",
    AIR_ID: "air_id",
    VPN_IP: "vpn_ip",
    LAN_IP: "local_ip",
    API_VERSION: "version",
    CPU_LOAD: "cpu_load",
    CPU_TEMP: "temp_c",
    MEM_USAGE: "mem_usage",
    DISK_USAGE: "disk_usage",
    BGC_FW_VER: "bgc_fw_ver",
    CLIENT_CNT: "client_count",
    STREAMING_FPS: "streaming_framesize_fps",
    STREAMING_CODEC: "streaming_codec",
    STREAMING_DES: "streaming_destination",
    STREAMING_BITRATE: "live_bitrate",
    STREAMING_STATUS: "streaming_status",
    LUT: "lut",
    CONTRAST: "contrast",
    BRIGHTNESS: "brightness",
    SATURATION: "saturation",
    TINT: "tint",
    SHUTTER: "shutter",
    F_STOP: "f_stop",
    ISO: "iso",
    WHITE_BALANCE: "white_balance",
    RECORDING_RESOLUTION: "resolution",
    RECORDING_FPS: "recording_fps",
    RECORDING_CODEC: "int_codec",
    CARD_TIME: "card_available_time",
    RECORDING_STATUS: "recording_status",
    ZCAM_FIRMWARE_VER: "zcam_firmware_ver",
    TIMESTAMP: "timestamp",
});

export const ROBOT_STATUS_DEFAULT_VALUE = "n/a";
export const ROBOT_UNKNOWN_VALUE = "Unknown";